import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import SparepartDetail from "./pages/SparepartDetail";
import AddSparepart from "./pages/AddSparepart";
import ReturnAdd from "./pages/ReturnAdd";
import "./App.css";
import ReturnEdit from "./pages/ReturnEdit";

function App() {
	return (
		<Router>
			<Routes>
				<Route
					path="/login"
					element={
						<PublicRoute>
							<Login />
						</PublicRoute>
					}
				/>
				<Route
					path="/"
					element={
						<ProtectedRoute>
							<Home />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/sparepart/:inqno"
					element={
						<ProtectedRoute>
							<SparepartDetail />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/add-sparepart"
					element={
						<ProtectedRoute>
							<AddSparepart />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/addretur"
					element={
						<ProtectedRoute>
							<ReturnAdd />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/editretur/:inqno"
					element={
						<ProtectedRoute>
							<ReturnEdit />
						</ProtectedRoute>
					}
				/>
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</Router>
	);
}

export default App;
